import { apiRequest } from "@core/services/api/apiRequest";
import { getAttribution } from "./attribution";

/** What a short form collects, whichever form it is. */
export type Inquiry = {
  email: string;
  firstName?: string;
  lastName?: string;
  organizationName?: string;
  message?: string;
};

/**
 * Send one of the site's short forms to intake.
 *
 * The newsletter and contact forms keep their own layouts, which the stepped
 * intake pages do not suit, but what they collect goes where every other
 * inquiry goes: recorded, listed in Bridge, and passed on to whoever the form
 * is configured to tell. `source` says where on the site it was sent from,
 * since the same form may sit on a page and in a dialog.
 */
export function submitInquiry(formSlug: string, inquiry: Inquiry, source: string) {
  return apiRequest(
    `/intake/${formSlug}/submit/`,
    "POST",
    {
      email: inquiry.email,
      first_name: inquiry.firstName ?? "",
      last_name: inquiry.lastName ?? "",
      organization_name: inquiry.organizationName ?? "",
      message: inquiry.message ?? "",
      submission_source: source,
      ...getAttribution(),
    },
    false
  );
}
